import { Box, H2 } from '@ouster/webviz-react-components';

import demoStyles from './inAppDemo.module.css';
import PublicPartnerPreviewContent from '../../components/publicSample/PublicPartnerPreviewContent';

export default function PublicPartnerPreview() {
  return (
    <Box className={`${demoStyles['page-container']}`}>
      <H2 fontWeight="medium" fontSize={30}>
        Exclusive Previews for Ouster Partners
      </H2>
      <PublicPartnerPreviewContent isPrivate={false} />
    </Box>
  );
}
